<template>
    <div class="grid grid-cols-5">
        <div class="flex items-center col-span-3">
            <div>
                <div>
                    <h2
                        data-animation="FADE_UP_TEXT"
                        data-animation-options="{
                            blur: false,
                            rotate: false,
                            skew: false,
                        }"
                        ref="title"
                        class="max-w-xl text-4xl font-display sm:text-6xl no-ligature"
                    >
                        {{ title }}
                    </h2>
                </div>
                <div>
                    <h3
                        data-animation="FADE_UP"
                        ref="year"
                        class="flex items-center mt-4 text-2xl italic font-light gap-x-3"
                    >
                        {{ from }}
                        <span class="w-16 h-[1px] bg-text inline-block"></span>
                        {{ to }}
                    </h3>
                </div>
            </div>
        </div>
        <div
            ref="imagesWrapper"
            class="flex-row flex-wrap hidden col-span-2 sm:flex"
        >
            <div
                data-animation="FADE_UP"
                v-for="(image, imageIndex) in images.slice(0, 4)"
                :key="image"
                :class="{
                    'mt-24': imageIndex === 0,
                    'mt-0': imageIndex === 1,
                    '-mt-24':
                        imageIndex !== 0 &&
                        imageIndex !== 1 &&
                        imageIndex % 2 === 1,
                }"
                class="w-1/2 overflow-hidden"
            >
                <img class="object-cover" :src="getImage(image)" alt="" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
    index: {
        type: Number,
        required: true,
    },
    title: {
        type: String,
        required: true,
    },
    from: {
        validator: (d: any) => {
            if (typeof d === 'number' || typeof d === 'string') return true;
            else return false;
        },
        required: true,
    },
    to: {
        validator: (d: any) => {
            if (typeof d === 'number' || typeof d === 'string') return true;
            else return false;
        },
        required: true,
    },
    images: {
        type: Array,
        required: true,
    },
});

const scrollOffset = ref(null);

// Methods
const getImage = (image) => {
    const path = `/assets/images/profile/${image}`;
    const modules = import.meta.glob('/assets/images/profile/*', {
        eager: true,
    });
    const mod = modules[path] as { default: string };
    return mod?.default;
    // console.log(
    //     new URL(`/assets/images/profile/${image}`, import.meta.url).href
    // );
    // return new URL(`/assets/images/profile/${image}`, import.meta.url).href;
};
// animateTxt() {
//             const anime = (this as any).$anime;
//             const imagesWrapper: HTMLElement = this.$refs
//                 .imagesWrapper as HTMLElement;

//             const images: Array<ChildNode> = [];

//             imagesWrapper.childNodes.forEach((iWrapper) => {
//                 images.push(iWrapper.childNodes[0]);
//             });

//             const animation = anime.timeline({
//                 easing: "easeInOutQuad",
//                 duration: 1250,
//                 autoplay: false,
//             });

//             animation.add({
//                 targets: [this.$refs.title, this.$refs.year],
//                 translateX: [-75, 0],
//                 opacity: [0, 1],
//                 delay(_el: any, i: number) {
//                     return i * 75;
//                 },
//             });

//             // Images Animation
//             animation.add(
//                 {
//                     targets: images,
//                     delay(_el: any, i: number) {
//                         return i * 225;
//                     },
//                     translateX: [-75, 0],
//                     opacity: [0, 1],
//                 },
//                 "-=1000"
//             );

//             setTimeout(() => {
//                 this.$locomotive.on("call", (e: any) => {
//                     if (e === `PROFILE_SECTION3_ANIMATE_${this.index}`)
//                         animation.play();
//                 });
//             }, 100);
//         },

// Hooks
onMounted(() => {
    // this.animateTxt();

    if (window.innerWidth < 450) scrollOffset.value = '150';
    else scrollOffset.value = '500';
});

// export default defineNuxtComponent({
//     name: "ProfileCareerComponent",
//     props: {
//         index: {
//             type: Number,
//             required: true,
//         },
//         title: {
//             type: String,
//             required: true,
//         },
//         from: {
//             validator: (d: any) => {
//                 if (typeof d === "number" || typeof d === "string") return true;
//                 else return false;
//             },
//             required: true,
//         },
//         to: {
//             validator: (d: any) => {
//                 if (typeof d === "number" || typeof d === "string") return true;
//                 else return false;
//             },
//             required: true,
//         },
//         images: {
//             type: Array,
//             required: true,
//         },
//     },
//     data() {
//         return {
//             scrollOffset: null as any,
//         };
//     },
//     mounted() {
//         this.animateTxt();

//         if (window.innerWidth < 450) this.scrollOffset = "150";
//         else this.scrollOffset = "500";
//     },
//     methods: {
//         animateTxt() {
//             const anime = (this as any).$anime;
//             const imagesWrapper: HTMLElement = this.$refs
//                 .imagesWrapper as HTMLElement;

//             const images: Array<ChildNode> = [];

//             imagesWrapper.childNodes.forEach((iWrapper) => {
//                 images.push(iWrapper.childNodes[0]);
//             });

//             const animation = anime.timeline({
//                 easing: "easeInOutQuad",
//                 duration: 1250,
//                 autoplay: false,
//             });

//             animation.add({
//                 targets: [this.$refs.title, this.$refs.year],
//                 translateX: [-75, 0],
//                 opacity: [0, 1],
//                 delay(_el: any, i: number) {
//                     return i * 75;
//                 },
//             });

//             // Images Animation
//             animation.add(
//                 {
//                     targets: images,
//                     delay(_el: any, i: number) {
//                         return i * 225;
//                     },
//                     translateX: [-75, 0],
//                     opacity: [0, 1],
//                 },
//                 "-=1000"
//             );

//             setTimeout(() => {
//                 this.$locomotive.on("call", (e: any) => {
//                     if (e === `PROFILE_SECTION3_ANIMATE_${this.index}`)
//                         animation.play();
//                 });
//             }, 100);
//         },
//     },
// });
</script>
